import React from 'react'

const UnsplashImageTile = (props) => {
  const handleImageSelect = () => {
    props.setSelectedImages(prev => {
      if (prev.find(image => image.id === props.imageId)) {
        return prev.filter(image => image.id !== props.imageId);
      }
      return [...prev, { url: props.imageUrl, id: props.imageId }];
    });
  };
  
  return(
    <div 
      className={`image-item ${props.selectedImages.filter(image => image.id === props.imageId).length > 0 ? 'selected' : ''}`}
      onClick={() => handleImageSelect()}
      key={props.index}
    >
      <img src={props.imageUrl} alt={`${props.index + 1}`} />
      <div className="checkbox">
        <input 
          type="checkbox"
          checked={props.selectedImages.filter(image => image.id === props.imageId).length > 0}
          onChange={() => handleImageSelect()}
        />
      </div>
    </div>
  )
}
export default UnsplashImageTile;

